/**
 * Frontend JS for Image Configurator
 */

( function( $ ) {
	const DEFAULT_TEXT_SETTINGS = {
		fontSize: 32,
		color: '#000000',
		defaultText: '',
		x: 0,
		y: 0,
		align: 'center',
		boxWidth: 250,
		boxHeight: 100,
	};
	const DEFAULT_UPLOAD_SETTINGS = {
		x: 0,
		y: 0,
		boxWidth: 250,
		boxHeight: 250,
		fit: 'contain',
		opacity: 100,
	};
	const canvasObjectUrls = {};

	// Initialize Configurator
	$( document ).on( 'gform_post_render', function( event, form_id, current_page ) {
		initConfigurator( form_id );
	} );

	function initConfigurator( form_id ) {
		const $form = $( '#gform_' + form_id );
		const $configurators = $form.find( '.ginput_container_configurator' );

		if ( $configurators.length === 0 ) {
			return;
		}

		$configurators.each( function() {
			const $container = $( this );
			const $canvas = $container.find( '.idea-ic-canvas' );
			
			if ( $canvas.length === 0 ) return;

			// Parse layers configuration
			let layersConfig = [];
			try {
				layersConfig = JSON.parse( $container.attr( 'data-layers' ) || '[]' );
			} catch ( e ) {
				console.error( 'Invalid layers configuration', e );
			}

			// Initial Update
			updateCanvas( $canvas, $form, layersConfig );

			// Bind change/input events to all inputs in this form
			// We can optimize this by only binding to fields present in layersConfig
			$form.on( 'change input', 'input, select, textarea', function() {
				updateCanvas( $canvas, $form, layersConfig );
			} );
		} );
	}

	function getLayerFieldType( layerConfig, $fieldContainer ) {
		if ( layerConfig && layerConfig.fieldType ) {
			return layerConfig.fieldType;
		}

		if ( $fieldContainer && $fieldContainer.length ) {
			const className = $fieldContainer.attr( 'class' ) || '';
			if ( className.indexOf( 'gfield--type-text' ) !== -1 ) {
				return 'text';
			}
		}

		return null;
	}

	function normalizeUploadSettings( settings ) {
		const merged = {
			...DEFAULT_UPLOAD_SETTINGS,
			...( settings || {} )
		};

		const x = parseInt( merged.x, 10 );
		const y = parseInt( merged.y, 10 );
		const boxWidth = parseInt( merged.boxWidth, 10 );
		const boxHeight = parseInt( merged.boxHeight, 10 );
		const opacity = parseInt( merged.opacity, 10 );

		return {
			x: Number.isNaN( x ) ? DEFAULT_UPLOAD_SETTINGS.x : x,
			y: Number.isNaN( y ) ? DEFAULT_UPLOAD_SETTINGS.y : y,
			boxWidth: Number.isNaN( boxWidth ) || boxWidth <= 0 ? DEFAULT_UPLOAD_SETTINGS.boxWidth : boxWidth,
			boxHeight: Number.isNaN( boxHeight ) || boxHeight <= 0 ? DEFAULT_UPLOAD_SETTINGS.boxHeight : boxHeight,
			fit: merged.fit === 'cover' ? 'cover' : 'contain',
			opacity: Number.isNaN( opacity ) ? DEFAULT_UPLOAD_SETTINGS.opacity : Math.max( 0, Math.min( 100, opacity ) ),
		};
	}

	function releaseCanvasObjectUrls( $canvas ) {
		const canvasKey = $canvas.attr( 'id' );
		if ( ! canvasKey || ! canvasObjectUrls[ canvasKey ] ) {
			return;
		}

		canvasObjectUrls[ canvasKey ].forEach( ( url ) => URL.revokeObjectURL( url ) );
		canvasObjectUrls[ canvasKey ] = [];
	}

	function rememberCanvasObjectUrl( $canvas, objectUrl ) {
		const canvasKey = $canvas.attr( 'id' );
		if ( ! canvasKey || ! objectUrl ) {
			return;
		}

		if ( ! canvasObjectUrls[ canvasKey ] ) {
			canvasObjectUrls[ canvasKey ] = [];
		}
		canvasObjectUrls[ canvasKey ].push( objectUrl );
	}

	function normalizeTextSettings( settings ) {
		const merged = {
			...DEFAULT_TEXT_SETTINGS,
			...( settings || {} )
		};

		const fontSize = parseInt( merged.fontSize, 10 );
		const x = parseInt( merged.x, 10 );
		const y = parseInt( merged.y, 10 );
		const boxWidth = parseInt( merged.boxWidth, 10 );
		const boxHeight = parseInt( merged.boxHeight, 10 );
		const normalizedBoxWidth = Number.isNaN( boxWidth ) ? DEFAULT_TEXT_SETTINGS.boxWidth : boxWidth;
		const normalizedBoxHeight = Number.isNaN( boxHeight ) ? DEFAULT_TEXT_SETTINGS.boxHeight : boxHeight;

		return {
			...merged,
			fontSize: Number.isNaN( fontSize ) ? DEFAULT_TEXT_SETTINGS.fontSize : fontSize,
			x: Number.isNaN( x ) ? DEFAULT_TEXT_SETTINGS.x : x,
			y: Number.isNaN( y ) ? DEFAULT_TEXT_SETTINGS.y : y,
			color: merged.color ? merged.color : DEFAULT_TEXT_SETTINGS.color,
			defaultText: typeof merged.defaultText === 'string' ? merged.defaultText : DEFAULT_TEXT_SETTINGS.defaultText,
			boxWidth: normalizedBoxWidth > 0 ? normalizedBoxWidth : DEFAULT_TEXT_SETTINGS.boxWidth,
			boxHeight: normalizedBoxHeight > 0 ? normalizedBoxHeight : DEFAULT_TEXT_SETTINGS.boxHeight,
			align: merged.align ? merged.align : DEFAULT_TEXT_SETTINGS.align,
		};
	}

	function updateCanvas( $canvas, $form, layersConfig ) {
		releaseCanvasObjectUrls( $canvas );
		$canvas.empty();

		// Let's use z-index to be explicit.
		// Item at index 0 (Top of list) gets highest z-index.
		// Item at index N (Bottom of list) gets lowest z-index.
		
		const totalLayers = layersConfig.length;

		layersConfig.forEach( ( layerConfig, index ) => {
			const fieldId = layerConfig.fieldId;
			const fieldLayers = layerConfig.layers || {};
			
			// Find the field in the form
			// Field ID in GF is usually just the number.
			// Input ID is input_{form_id}_{field_id}
			// But for radio/checkbox, it's input_{form_id}_{field_id}_{choice_index}

			const $fieldContainer = $form.find( '#field_' + $form.attr( 'id' ).replace( 'gform_', '' ) + '_' + fieldId );
			
			// If field not found, skip
			if ( $fieldContainer.length === 0 ) return;

			const fieldType = getLayerFieldType( layerConfig, $fieldContainer );

			if ( fieldType === 'text' ) {
				const $input = $fieldContainer.find( 'input[type="text"], textarea' ).first();
				const textSettings = normalizeTextSettings( layerConfig.textSettings );
				const inputValue = $input.length ? $input.val() : '';
				const textValue = inputValue !== '' ? inputValue : ( textSettings.defaultText || '' );
				if ( textValue ) {
					const zIndex = totalLayers - index;
					const textEl = $( '<div>' ).text( textValue ).css( {
						'position': 'absolute',
						'top': textSettings.y + 'px',
						'left': textSettings.x + 'px',
						'color': textSettings.color,
						'font-size': textSettings.fontSize + 'px',
						'text-align': textSettings.align,
						'white-space': 'pre-wrap',
						'pointer-events': 'none',
						'z-index': zIndex
					} );
					if ( textSettings.boxWidth > 0 ) {
						textEl.css( 'width', textSettings.boxWidth + 'px' );
					}
					if ( textSettings.boxHeight > 0 ) {
						textEl.css( 'height', textSettings.boxHeight + 'px' );
						textEl.css( 'overflow', 'hidden' );
					}
					$canvas.append( textEl );
				}
				return;
			}

			if ( fieldType === 'fileupload' ) {
				const $fileInput = $fieldContainer.find( 'input[type="file"]' ).first();
				const fileInput = $fileInput.get( 0 );
				if ( ! fileInput || ! fileInput.files || ! fileInput.files.length ) {
					return;
				}
				const file = fileInput.files[ 0 ];
				if ( ! file || ! file.type || file.type.indexOf( 'image/' ) !== 0 ) {
					return;
				}

				const uploadSettings = normalizeUploadSettings( layerConfig.uploadSettings );
				const objectUrl = URL.createObjectURL( file );
				rememberCanvasObjectUrl( $canvas, objectUrl );
				const zIndex = totalLayers - index;

				const uploadImage = $( '<img>' ).attr( 'src', objectUrl ).css( {
					'position': 'absolute',
					'top': uploadSettings.y + 'px',
					'left': uploadSettings.x + 'px',
					'width': uploadSettings.boxWidth + 'px',
					'height': uploadSettings.boxHeight + 'px',
					'object-fit': uploadSettings.fit,
					'opacity': uploadSettings.opacity / 100,
					'z-index': zIndex
				} );
				$canvas.append( uploadImage );
				return;
			}

			let selectedValues = [];

			// Check based on field type (we can guess by looking for inputs)
			const $inputs = $fieldContainer.find( 'input:checked, option:selected' );
			
			$inputs.each( function() {
				selectedValues.push( $( this ).val() );
			} );

			// For each selected value, check if there is a mapped image
			selectedValues.forEach( val => {
				if ( fieldLayers[ val ] ) {
					const imageUrl = fieldLayers[ val ];
					
					// Z-index: Top of list (index 0) -> High z-index
					const zIndex = totalLayers - index;

					const img = $( '<img>' ).attr( 'src', imageUrl ).css( {
						'position': 'absolute',
						'top': 0,
						'left': 0,
						'width': '100%',
						'height': '100%',
						'object-fit': 'contain',
						'z-index': zIndex
					} );
					
					$canvas.append( img );
				}
			} );
		} );
	}

} )( jQuery );
